<template>
    <div ref="drawingRoot" style="background-color: white">

        <div class="drawing-toolbar">


            <div @click="toggleLeftPane" class="mobile layer_round_icon button-iconbackcolor button-iconfontcolor">
                <v-icon class="button-iconfontcolor">mdi-format-list-bulleted-square</v-icon>
            </div>

            <div @click="reset" class="layer_round_icon button-iconbackcolor button-iconfontcolor">
                <v-icon class="button-iconfontcolor">mdi-fit-to-page-outline</v-icon>
            </div>

            <div @click="zoomin" class="layer_round_icon button-iconbackcolor button-iconfontcolor">
                <v-icon class="button-iconfontcolor">mdi-magnify-plus-outline</v-icon>
            </div>

            <div @click="zoomout" class="layer_round_icon button-iconbackcolor button-iconfontcolor">
                <v-icon class="button-iconfontcolor">mdi-magnify-minus-outline</v-icon>
            </div>

            <div @click="navPrevious" v-if="!this.project.isFirstDrawing" class="layer_round_icon button-iconbackcolor button-iconfontcolor">
              <v-icon class="button-iconfontcolor">mdi-arrow-left-bold</v-icon>
            </div>

            <div @click="navSubDrawings" v-if="this.project.hasSubDrawings" class="layer_round_icon button-iconbackcolor button-iconfontcolor">
              <v-icon class="button-iconfontcolor" :title="project.uxd.labelshowsubassemblies + ' (' + project.subDrawingsCount + ')'">mdi-sitemap-outline</v-icon>
            </div>

            <div @click="navNext" v-if="!this.project.isLastDrawing" class="layer_round_icon button-iconbackcolor button-iconfontcolor">
                <v-icon class="button-iconfontcolor">mdi-arrow-right-bold</v-icon>
            </div>
            <div v-if="this.project.uxd.hideheader == '1'" @click="openSearch" class="layer_round_icon button-iconbackcolor button-iconfontcolor">
                <v-icon class="button-iconfontcolor">mdi-magnify</v-icon>
            </div>
            <div v-if="this.project.uxd.hideheader == '1' && this.project.locales.length > 1" @click="openLocale" class="layer_round_icon button-iconbackcolor button-iconfontcolor">
                <v-icon class="button-iconfontcolor">mdi-web</v-icon>
            </div>
            <div v-if="this.project.features.createpdfapi" @click="printDrawing" class="layer_round_icon button-iconbackcolor button-iconfontcolor icon-right">
                <v-icon class="button-iconfontcolor">{{project.isPrinting? 'mdi-timer-sand' : 'mdi-printer'}}</v-icon>
            </div>
        </div>
        <div id="theDrawing" v-on:wheel="handleScroll" v-html="selectedDrawingSrc" :style="getStyle_TheDrawing()">
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'
    import $ from 'jquery'
    import {EventBus} from '../services/event-bus.js'
    import Panzoom from '../services/panzoom'

    export default {
        name: 'Drawing',
        data() {
            return {
                zoom: 1.0
            }
        },
        mounted: function () {
            EventBus.$on('reset-drawing', () => {
                this.reset()
            })
            EventBus.$on('zoomin-drawing', () => {
                this.zoomin()
            })
            EventBus.$on('zoomout-drawing', () => {
                this.zoomout()
            })
            this.$store.watch(
                () => this.$store.getters.selectedDrawingId,
                (newVal) =>
                    setTimeout(() => this.showDrawing(newVal))
            )
            this.showDrawing(this.$store.getters.selectedDrawingId)
        },
        beforeDestroy() {
            if (this.selectedHotspotIdUnwatch) {
                this.selectedHotspotIdUnwatch()
            }
        },
        computed: {
            ...mapState([
                'project',
                'session'
            ]),
            ...mapGetters([
                'selectedDrawingSrc'
            ])
        },
        methods: {
            ...mapActions([
                'getDrawing',
                'getHotspots',
                'selectHotspot',
                'toggleLeftPane',
                'updateCheckedHotspots',
                'goToPreviousDrawing',
                'goToNextDrawing',
                'printCurrentDrawing',
                'goToSubDrawings'
            ]),
            ...mapMutations([
                'updateSelectedHotspotLocation'
            ]),
            reset() {
                this.zoomer.reset()

            },
            zoomin() {
                this.zoomer.zoomIn({increment: +0.08, animate: true})
            },
            zoomout() {
                if (this.zoomer.getScale() > 0.01) {
                    this.zoomer.zoomOut({increment: +0.08, animate: true})
                }
            },
            goTo(x, y) {
                this.zoomer.pan(x, y, {animate: true})
            },
            showSelectedHotspot() {
                if (this.project.uxd.zoomonpart === 'true') {
                    this.goTo(this.project.selectedHotspot.location.x, this.project.selectedHotspot.location.y)
                }
            },
            handleScroll(evt) {
                this.zoomer.zoomWithWheel(evt)
            },
            navNext() {
              this.goToNextDrawing();
            },
            navPrevious() {
              this.goToPreviousDrawing();
            },
            navSubDrawings() {
              this.goToSubDrawings();
            },
            showDrawing(newDrawingId) {
                if (newDrawingId !== undefined && newDrawingId !== -1) {
                    this.$root.$emit('closeDetailsEvent')
                    let svgElem = $('#theDrawing svg').get(0)
                    if (!svgElem)
                        return
                    const container = $('#theDrawing')
                    const svgRect = svgElem.getBoundingClientRect()
                    if (svgRect.width === 0 || container.width() === 0) {
                        return;
                    }
                    let newScale = 1.0
                    let startX = 0, startY = 0
                    if ((container.height() / svgRect.height) - (container.width() / svgRect.width) < 0) {
                        newScale = container.height() / svgRect.height
                        startY = (container.height() - (svgRect.height)) / (2 * newScale)
                    } else {
                        newScale = container.width() / svgRect.width
                        startX = (container.width() - (svgRect.width)) / (2 * newScale)
                        startY = ((svgRect.height * newScale) - container.height()) / (2 * newScale)
                    }
                    this.zoomer = Panzoom(svgElem, {
                        startScale: newScale,
                        startX: startX,
                        startY: startY,
                    });
                    let app = this;
                    $('svg .pcg_hotspot').unbind();
                    app.svgClickHandler = $('svg .pcg_hotspot').click(function () {
                        // eslint-disable-next-line no-console
                        let twin = $(this).attr('data-twin');
                        let id = $(this).attr('id');
                        let hotspotId = twin === '-1' ? parseInt(id.substring(2)) : parseInt(twin);
                        let item = document.getElementById('hsit' + hotspotId);
                        if(item) {
                          let prevItem = item.previousSibling;
                          if(prevItem)
                            prevItem.scrollIntoView();
                          else
                            document.querySelector(".parts-grid-wrapper").scroll({top:0, behavior:'smooth'});
                        }
                        app.$store.commit('updatePanAndZoomOnHotspotSelection', false);
                        app.selectHotspot({ hotspotId : hotspotId, specificFunc: -1});
                        app.$emit('hotspot-clicked');
                    });
                    $('svg .pcg_hotspot').on('touchend', function () {
                        // eslint-disable-next-line no-console
                        let twin = $(this).attr('data-twin');
                        let id = $(this).attr('id');
                        let hotspotId = twin === '-1' ? parseInt(id.substring(2)) : parseInt(twin);
                        let item = document.getElementById('hsit' + hotspotId);
                        if(item) {
                          let prevItem = item.previousSibling;
                          if(prevItem)
                            prevItem.scrollIntoView();
                          else
                            document.querySelector(".parts-grid-wrapper").scroll({top:0, behavior:'smooth'});
                        }
                        app.$store.commit('updatePanAndZoomOnHotspotSelection', false);
                        app.selectHotspot({ hotspotId : hotspotId, specificFunc: -1});
                        app.$emit('hotspot-clicked');
                    })
                    app.selectedHotspotIdUnwatch = app.$store.watch(
                        () => app.$store.getters.selectedHotspotId,
                        newId => this.panToHotspotId(newId));

                    this.updateCheckedHotspots();

                }
            },
            panToHotspotId(hotspotId) {
                // eslint-disable-next-line no-console
                $('svg .pcg_hotspot').removeClass('theme-highlightcolor')
                if (hotspotId) {
                    let hotspot = $('#hs' + hotspotId.toString())
                    let svgDoc = $('svg')[0]
                    if (!svgDoc || !hotspot) {
                        return
                    }
                    hotspot.addClass('theme-highlightcolor ')
                    hotspot = hotspot[0]
                    if (!hotspot || !this.$refs.drawingRoot) {
                        return
                    }
                    $('.pcg_hotspot[data-twin="' + hotspotId + '"]').addClass('theme-highlightcolor')


                    const scale = this.zoomer.getScale();
                    const container = $('#theDrawing');
                    const svgRect = svgDoc.getBoundingClientRect();
                    const hotspotRect = hotspot.getBoundingClientRect();
                    const hotspotX = svgRect.x - hotspotRect.x;
                    const hotspotY = svgRect.y - hotspotRect.y;
                    const transXToCenter = ((container.width() - hotspotRect.width) / 2);
                    const transYToCenter = ((container.height() - hotspotRect.height) / 2);
                    const transX = ((((svgRect.width / scale) - svgRect.width) / 2) - transXToCenter);
                    const transY = ((((svgRect.height / scale) - svgRect.height) / 2) - transYToCenter);
                    const x = (hotspotX - transX) / scale;
                    const y = (hotspotY - transY) / scale;
                    this.updateSelectedHotspotLocation({x: x, y: y});
                    if (!this.$store.state.project.panAndZoomOnHotspotSelection) {
                        return;
                    }
                    this.showSelectedHotspot();
                }
            },
            getStyle_TheDrawing() {
              let trayHeight = this.project.uxd.hidedetailstray == '0' ? 60 : 0;
              let headerHeight = this.project.uxd.hideheader == '0' ? 200 : 40;
              return 'height:calc(100vh - ' + parseInt(trayHeight + headerHeight) + 'px)';
            },
            openSearch() {
              EventBus.$emit('open-search-dialog', true);
            },
            openLocale() {
              EventBus.$emit('open-locale-dialog', true);
            },
            printDrawing() {
                this.printCurrentDrawing();
            }
        }
    }
</script>
